"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isErrorLike(value) {
    // Use '!=' to check value is not null or undefined
    return value != null && typeof value.message === "string";
}
/**
 * Translates un-typed errors that may come from external sources into a standardized `Error`.
 * If the param is already an Error, it will be returned as-is.
 * If it's a string, is falsy, or has a message field, a new Error will be created with that value.
 * Otherwise a new Error will be created stringifying the object.
 * @param error The thrown error to wrap in an object
 */
function toError(error) {
    if (error instanceof Error) {
        return error;
    }
    else if (typeof error === "string") {
        return new Error(error);
    }
    else if (typeof error === "object" && isErrorLike(error)) {
        return new Error(error.message);
    }
    else if (error === undefined) {
        return new Error(error);
    }
    else {
        return new Error(JSON.stringify(error));
    }
}
exports.toError = toError;
/**
 * @deprecated Use toError instead; this has been renamed for consistency
 */
exports.asError = toError;
//# sourceMappingURL=toError.js.map